

/**
 * @summary Contains the main menu item preact component.
 */

import { h, Component } from 'preact';
import Menu from './Menu';

/**
 * @summary Main menu item preact component.
 *
 * @export
 * @class
 * @extends {Component}
 */
export default class MenuItem extends Component {
	constructor( props ) {
		super( props );

		this.state = {
			open: false
		};

		this.indirectClose = this.indirectClose.bind( this );
		this.onTouch = this.onTouch.bind( this );
		this.onRef = this.onRef.bind( this );
	}

	componentDidMount() {
		if ( this.props.children.length > 0 ) {
			document.addEventListener( 'touchstart', this.indirectClose );
		}
	}

	componentWillUnmount() {
		document.removeEventListener( 'touchstart', this.indirectClose );
	}

	/**
	 * @summary Preact ref call.
	 *
	 * @param {Node} element The element to reference.
	 */
	onRef( element ) {
		this.ele = element;

		if ( typeof this.props.itemRef === 'function' ) {
			this.props.itemRef( element );
		}
	}

	/**
	 * @summary Queries whether an element is a child of this component's root.
	 *
	 * @param {Node} element The element to query about.
	 * @returns {bool} Returns true if the given element is a child.
	 */
	isChild( element ) {
		if ( element === null ) {
			return false;
		}

		if ( element === this.ele ) {
			return true;
		}

		return this.isChild( element.parentElement );
	}

	/**
	 * @summary Closes the submenu (if any and open) on elsewhere touch.
	 *
	 * @listens document:touchstart
	 *
	 * @param {TouchEvent} event The object representing the touch event.
	 */
	indirectClose( event ) {
		if ( this.state.open && ! this.isChild( event.srcElement ) ) {
			this.setState({
				open: false
			});
		}
	}

	/**
	 * @summary Opens the submenu (if any) on touch.
	 *
	 * @listens document:touchend
	 *
	 * @param {TouchEvent} event The object representing the touch event.
	 */
	onTouch( event ) {
		if ( this.props.children.length > 0 && ! this.state.open ) {
			event.preventDefault();

			this.setState({
				open: true
			});
		}
	}

	/**
	 * @summary Returns classes attribute value to add to an anchor element.
	 *
	 * @returns {String} The class attribute value.
	 */
	linkClasses() {
		const baseName = `${
			this.props.type === 'normal' ?
				'c-primary-menu' :
				'c-drawer-menu'
		}__link`;
		let classes = `${baseName} ${baseName}--${this.props.depth === 0 ? 'top' : 'sub'}`;

		if ( this.props.activeTrail ) {
			classes += ' is-active-trail';
		}

		return classes;
	}

	render({ url, title, depth, type, hidden, children = [] }, { open }) {
		return (
			<li
				onTouchEnd={this.onTouch}
				class={open ? 'is-open' : ''}
				style={hidden ? 'visibility: hidden' : ''}
				ref={this.onRef}
			>
				<a href={url} class={this.linkClasses()}>{title}</a>
				{children.length > 0 &&
					<Menu menuTree={children} depth={depth + 1} type={type}/>
				}
			</li>
		);
	}
}



// WEBPACK FOOTER //
// ./src/js/components/MenuItem.js